import Grid from "@mui/material/Grid2";

import { useAlerts } from "../../../Components/hooks/cloudAnalytics/alerts/useAlerts";
import { ActiveAlertsCard } from "./Cards/ActiveAlertsCard";
import { ActiveBudgetsCard } from "./Cards/ActiveBudgetsCard";
import { ActiveCostAnomaliesCard } from "./Cards/ActiveCostAnomaliesCard";
import { AutomateCloudWasteCard } from "./Cards/AutomateCloudWasteCard";
import { CommitmentsCard } from "./Cards/CommitmentsCard";

type CloudCostsSectionProps = {
  cloudFlowsCount: number;
  cloudFlowsRisk: number;
  activeCommitmentsAtRiskCount: number;
  commitmentsCostAtRisk: number;
  loading: boolean;
  anomaliesAtRisk: number;
  numberOfAnomaliesInLast30Days: number;
  numberOfAnomalies: number;
  numberOfBudgets: number;
  numberOfBudgetsNearThreshold: number;
  budgetsAtRisk: number;
};

export const CloudCostsSection = ({
  cloudFlowsCount,
  cloudFlowsRisk,
  activeCommitmentsAtRiskCount,
  commitmentsCostAtRisk,
  loading,
  anomaliesAtRisk,
  numberOfAnomaliesInLast30Days,
  numberOfAnomalies,
  numberOfBudgets,
  numberOfBudgetsNearThreshold,
  budgetsAtRisk,
}: CloudCostsSectionProps) => {
  const [alertList, loadingAlerts] = useAlerts();

  // Simplified logic to ensure exactly 4 cards (2 fixed + 2 conditional)
  const showAlertsCard = alertList.length > 0 && cloudFlowsCount === 0 && activeCommitmentsAtRiskCount === 0;

  let showCommitmentsCard = false;
  let showCloudWasteCard = false;

  if (alertList.length === 0) {
    // No alerts: show both commitment and cloud waste regardless of values
    showCommitmentsCard = true;
    showCloudWasteCard = true;
  } else if (showAlertsCard) {
    // Show alerts + commitments (as fallback)
    showCommitmentsCard = true;
  } else {
    // Has alerts but not showing alerts card: show commitment and cloud waste
    showCommitmentsCard = true;
    showCloudWasteCard = true;
  }

  return (
    <Grid container spacing={2} sx={{ width: "100%" }}>
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <ActiveCostAnomaliesCard
          numberOfAnomalies={numberOfAnomalies}
          numberOfAnomaliesInLast30Days={numberOfAnomaliesInLast30Days}
          loading={loading}
          anomaliesAtRisk={anomaliesAtRisk}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <ActiveBudgetsCard
          numberOfBudgets={numberOfBudgets}
          numberOfBudgetsNearThreshold={numberOfBudgetsNearThreshold}
          loading={loading}
          totalCostAtRisk={budgetsAtRisk}
        />
      </Grid>

      {showCommitmentsCard && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <CommitmentsCard
            activeCommitmentsAtRiskCount={activeCommitmentsAtRiskCount}
            costAtRisk={commitmentsCostAtRisk}
            loading={loading}
          />
        </Grid>
      )}

      {showCloudWasteCard && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <AutomateCloudWasteCard cloudFlowsCount={cloudFlowsCount} totalPotentialSavings={cloudFlowsRisk} />
        </Grid>
      )}

      {showAlertsCard && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <ActiveAlertsCard alertList={alertList} loading={loadingAlerts} />
        </Grid>
      )}
    </Grid>
  );
};
